import { opendaysSliderMetric } from "./blocks/metrics.js";
import "./blocks/region.js";
import "./blocks/region-list.js";
import "./blocks/burger-menu.js";
import "./blocks/dropdown.js";
import "./blocks/ol-dropdown.js";
import "./blocks/dragscroll.js";
import "./blocks/responsive-tabs.js";
import "./blocks/script.js";
import "./blocks/picker.js";
import "./blocks/search-result.js";
import "./blocks/rating.js";
import "./blocks/new-tooltip-fixed.js";
import "./blocks/hidden-video.js";

import { initializeCookieBanner } from "./blocks/cookie-banner.js";
import { initModal } from "./blocks/modal.js";
import { initModals } from "./blocks/modals.js";
import { initTabs } from "./blocks/tabs.js";
import { initSwiper } from "./blocks/vertical-slider.js";
import { initSlider } from "./blocks/sliders.js";
import { startTimer, parseDateString } from "./blocks/timer.js";
import { initProfessionsList } from "./blocks/professions-list.js";
import { initRnSelects } from "./blocks/rn-select.js";
import { initDropDown } from "./blocks/modal-dropdown.js";
import { initGallery } from "./blocks/gallery-modal.js";
import { addImageLink } from "./blocks/image-link.js";
import { initTables } from "./blocks/table.js";
import { singleFilterInit } from "./blocks/single-filter.js";
import { initVideosIframe } from "./blocks/video-iframe.js";
import { iconHelp } from "./blocks/icon-help.js";
import { partnerCard } from "./blocks/partner-card.js";
import { citationResource } from "./blocks/citation-resource.js";

window.startTimer = startTimer;
window.parseDateString = parseDateString;

window.addEventListener("DOMContentLoaded", () => {
  opendaysSliderMetric();
  initModal();
  initModals();
  initSlider();
  initProfessionsList();
  initSwiper();
  initTabs();
  initRnSelects();
  initTables();
  initDropDown();
  initializeCookieBanner();
  initGallery();
  addImageLink();
  singleFilterInit();
  initVideosIframe();
  iconHelp();
  partnerCard();
  citationResource();
});
